module.exports = __webpack_public_path__ + "static/img/envelope02en.d2ed45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope02en.png
// module id = e+8E
// module chunks = 1